<div class="import-source-modal">
  <div class="import-source-modal__header">
    <h3 class="import-source-modal__title">Import data source</h3>
    <p class="import-source-modal__subtitle">
      Choose how you'd like to import.
      For RISE and Confluence, set credentials in
      <a class="import-source-modal__link" (click)="goToSettings()">API Settings</a>.
    </p>
  </div>

  <div class="import-source-modal__grid">
    <button
      type="button"
      class="source-card"
      (click)="handleOption1Click('ecr')"
    >
      <span class="material-icons source-card__icon" translate="no">science</span>
      <span class="source-card__name">RISE</span>
      <span class="source-card__desc">Import from RISE (ECR)</span>
    </button>

    <button
      type="button"
      class="source-card"
      (click)="handleOption1Click('confluence')"
    >
      <span class="material-icons source-card__icon" translate="no">integration_instructions</span>
      <span class="source-card__name">Confluence</span>
      <span class="source-card__desc">Sync Confluence pages</span>
    </button>

    <button
      type="button"
      class="source-card"
      (click)="handleOption1Click('veeva')"
    >
      <span class="material-icons source-card__icon" translate="no">medication</span>
      <span class="source-card__name">Veeva</span>
      <span class="source-card__desc">Import from Veeva Vault</span>
    </button>

    <button
      type="button"
      class="source-card"
      (click)="handleOption1Click('manual')"
    >
      <span class="material-icons source-card__icon" translate="no">upload_file</span>
      <span class="source-card__name">Manual upload</span>
      <span class="source-card__desc">Upload files directly</span>
    </button>
  </div>
</div>
